import { defineMessages } from 'react-intl';

export const messages = defineMessages({
  customerEmail: {
    description: 'filterOptions.customerEmail',
    defaultMessage: 'Customer Email',
    id: 'brt8SR',
  },
  provider: {
    description: 'filterOptions.provider',
    defaultMessage: 'Provider',
    id: 'i/5NZI',
  },
  receivedDate: {
    description: 'filterOptions.receivedDate',
    defaultMessage: 'Received Date',
    id: 'QzD40P',
  },
  shipTo: {
    description: 'filterOptions.shipTo',
    defaultMessage: 'Return To',
    id: 'CCLFwY',
  },
  returningParty: {
    description: 'filterOptions.returningParty',
    defaultMessage: 'Returning Party',
    id: 'xg6vbl',
  },
  city: {
    description: 'filterOptions.returns-city',
    defaultMessage: 'City',
    id: 'bkJ48V',
  },
  country: {
    description: 'filterOptions.returns-country',
    defaultMessage: 'Country',
    id: 'oQjbDI',
  },
  label: {
    description: 'filterOptions.returns-label',
    defaultMessage: 'Label',
    id: '6pDiur',
  },
  state: {
    description: 'filterOptions.returns-state',
    defaultMessage: 'State',
    id: 'xnFWKf',
  },
  rmaNumber: {
    description: 'filterOptions.rmaNumber',
    defaultMessage: 'RMA #',
    id: 'NcRnsk',
  },
});
